"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// checks if the persons configuration equals the paxes amounts
function personsAndPaxesMatch(_state, getters) {
    var persons = getters['persons/asAgeGroups'];
    var paxes = getters['pax/groups'];
    return (persons.A === paxes.A) &&
        (persons.J === paxes.J) &&
        (persons.C === paxes.C);
}
exports.default = personsAndPaxesMatch;
//# sourceMappingURL=persons_and_paxes_match.js.map